import { HelpCenter } from "../user-account/HelpCenter";

export const WebFaq = () => (
  <>
    <div className="web_padding_x web_padding_y">
      <HelpCenter showTitle={false} />
    </div>
  </>
);
